export default function (other) {
  other = other || {};
  return {
    range: other.range || { from: null, until: null },
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    desks: other.desks || [],
    // SALES | RETENTION | null (null = all departments)
    department: other.department || null,
  };
}
